import { Injectable } from '@angular/core';
import { JsonValue } from '@technocom/common/platform';
import { EntityOptions, EntityType } from '@technocom/data/core';
import { EntityFactoryServiceBase } from '@technocom/data';
import { Localizable, LocalizableDTO } from '@app/shared/models/localizable/localizable';

@Injectable()
export class LocalizableFactoryService<
  V extends LocalizableDTO = any,
  T extends Localizable<V> = any,
  C extends EntityType<V, T> = any,
> extends EntityFactoryServiceBase<V, T, C> {
  parse(json: JsonValue, options?: EntityOptions): T {
    const type = this.getEntity();
    const plainDefLang: any = {};
    // Получаем поля для локализации в дочерний объект
    const fields = (type as any).localizableFields();
    const factory = this.getProvider().getFactory((type as any).contentType);
    fields.forEach(field => {
      plainDefLang[field.serialization.from ?? field.name] = json[field.serialization.from ?? field.name];
    });
    // устанавливаем метку на язык
    plainDefLang.language = 'special';

    const preFab = super.parse(json);
    const alreadyParsed = preFab.get('contents');
    preFab.set(
      'contents',
      alreadyParsed ? preFab.get('contents').concat(factory.parse(plainDefLang)) : [factory.parse(plainDefLang)],
    );
    return preFab;
  }
}
